import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { GridHeaderStatisticsComponent } from "./grid-header-statistics/grid-header-statistics.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    GridHeaderStatisticsComponent,
  ],
  exports: [
    GridHeaderStatisticsComponent,
  ],

})
export class StatisticsModule { }
